// import Component from './index';

export default {
  // component: Component,
  component: load(() => import(/* webpackChunkName: "Live" */ './index')),
  priority: 9,
  permissions: ['Dashboard'],
  name: 'Live',
  icon: 'eye',
  drawer: true,
};

